
    import I18n from 'i18nObj';
    
      import 'translations/wiki_pages';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('wiki_pages');
  